import studyImage from 'assets/images/study.webp';
import Button from 'components/Button';
import MyImage from 'components/MyImage';
import Spacing from 'components/Spacing';
import { Box, HStack, VStack } from 'components/Stack';
import Text from 'components/Text';
import RightArrow from 'components/icons/RightArrow';
import { useResponsive } from 'hooks/useResponsive';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

const SectionA = ({ onClickBook }: { onClickBook?: () => void }) => {
  const theme = useTheme();
  const { t, i18n } = useTranslation();
  const { isSmallScreen } = useResponsive();

  return (
    <section className='sectionA'>
      <VStack className='container' $padding='0 0.5rem'>
        <HStack $justifyContent='center' $position='relative'>
          <Box
            $flex={10}
            $padding='1rem 0.5rem'
            $paddingTop='2rem'
            $zIndex='10'
          >
            <Text
              $lineHeight='2'
              fontWeight={600}
              as='h2'
              fontSize={isSmallScreen ? '1.8rem' : '2.2rem'}
            >
              {t('카공24타이틀')}
            </Text>
          </Box>

          <Box
            $position='absolute'
            $justifyContent='center'
            $alignItems='flex-end'
            $right={isSmallScreen ? '-13rem' : '0rem'}
            $top='3rem'
            $zIndex='0'
          >
            <MyImage
              src={studyImage}
              width={200}
              height={200}
              alt='study image'
              $objectFit='cover'
              $objectPosition='left'
            />
          </Box>
        </HStack>
        <Spacing margin='1rem' />
        <VStack $padding='0rem 0.5rem' $width='100%' $gap='2rem'>
          <Text $lineHeight='1.8rem'>
            {
              t('카공24소개')
            }
          </Text>

          <Button
            $bgColor={theme.color.secondaryGradient}
            $width='100%'
            $marginLeft='auto'
            $marginRight='auto'
            $padding='1rem 1.5rem'
            $alignItems='center'
            $justifyContent='space-between'
            $flexDirection='row'
            onClick={onClickBook}
          >
            <Text color={theme.color.grey100} fontSize='1rem' fontWeight={700}>
              {t('지금예약')}
            </Text>
            <RightArrow size={16} color={theme.color.grey100} />
          </Button>
        </VStack>
      </VStack>
    </section>
  );
};

export default SectionA;
